import type { Instrument } from '../services/api';

export type InstrumentUsageKbRef = { id: string; title?: string | null };

export function parseInstrumentUsageKbRef(
  instr: Partial<Instrument> | null | undefined
): InstrumentUsageKbRef | null {
  if (!instr) return null;
  const raw = instr.usageInstructionKnowledgeBaseId as unknown;
  if (!raw) return null;
  if (typeof raw === 'string') {
    const id = raw.trim();
    return id ? { id, title: null } : null;
  }
  if (typeof raw === 'object' && raw !== null && '_id' in raw) {
    const o = raw as { _id: string; title?: string };
    const id = String(o._id || '').trim();
    if (!id) return null;
    return { id, title: o.title ?? null };
  }
  return null;
}
